//#region DevExtreme Imports

import DevExpress from 'devextreme'
import DataSource from 'devextreme/data/data_source'

//#endregion

import { IUserSession, LocalizationHelper, EventsNames, ConfigHelper, TypeHelper, TemplateHelper } from "../../../helpers"
import { DescrType } from "../../common/select-add-descr/select-add-descr.directive"
import { Enums, Activity } from "../../../models/common"
import { DescrModel } from "../../api/api.models"
import { OpDashboard, OpDashboardData } from "../../../models/custom"
import { BackwardCompatibilityHelper } from "../../../helpers/backward-compatibility-helper"
import { OpChangeState } from "../../../models/common/enums"
import { OpDataList } from "../../../models/util"

export type DashboardCreateEditPopupOptions = {
    dashboardModel: OpDashboard
    isNew?: boolean
    onSubmitCallback: (modelToSave: OpDashboard) => void
    descriptions: DescrModel[] //!!TODO change to opDescr after it will be changed in select-add-descr
}

export class DashboardCreateEditPopupController implements ng.IComponentController {
    private options: DashboardCreateEditPopupOptions

    private dashboardDescription: DescrModel
    private isEditPopupLoading: boolean
    private popupOptions: DevExpress.ui.dxPopupOptions
    private popup: DevExpress.ui.dxPopup
    private formOptions: DevExpress.ui.dxFormOptions
    private form: DevExpress.ui.dxForm
    private addDashboardSelectboxOptions: DevExpress.ui.dxSelectBoxOptions
    private selectedDashboardType: number
    private applyChangesButtonOptions: DevExpress.ui.dxButtonOptions
    private cancelChangesButtonOptions: DevExpress.ui.dxButtonOptions
    private onDashboardDescrSelectionChanged: (elementId: number, propertyName: string, descr: DescrModel) => void

    //#region delete dashboard button and confirmation popup
    private deleteDashboardButtonOptions: DevExpress.ui.dxButtonOptions
    private delDashboardButtonVisible: boolean
    private deleteConfirmationPopupId: number
    private deleteConfirmationPopupTitle: string
    private applyDashboardDelete: () => void
    //#endregion    

    constructor(
        private $scope: ng.IScope,
        private $q: ng.IQService,
        private userSession: IUserSession
    ) {
        this.deleteConfirmationPopupId = new Date().getTime()
    }

    //#region IComponentController Implementation
    public $onChanges(changes: { [index: string]: ng.IChangesObject<any> }): void {
        if (TypeHelper.isOptionsDefined(changes)) {
            this.initialize();
        }
    }
    //#endregion IComponentController Implementation End

    private initialize(): void {
        this.setOptions()
        this.showPopup()
    }

    private showPopup(): void {
        this.getPopup().then((popup: DevExpress.ui.dxPopup) => {
            this.isEditPopupLoading = true
            this.selectedDashboardType = this.options.dashboardModel.type || Enums.DashboardType.Standard
            popup.option({
                title: this.options.isNew
                    ? LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AddNewDashboard)
                    : LocalizationHelper.getLocalizedText(LocalizationHelper.Text.EditDashboardOptions)
            })
            popup.show().then(() => {
                this.isEditPopupLoading = false
            })
        })
    }

    private setOptions(): void {
        if (this.options.dashboardModel.type == null) {
            this.options.dashboardModel.type = Enums.DashboardType.Standard
        }

        if (this.options.dashboardModel.dataList) {
            const data = this.options.dashboardModel.dataList.toArray().filter((d: OpDashboardData) => d.idDataType === Enums.DataType.DASHBOARD_DX_PATH)
            this.options.dashboardModel['url'] = data != null && data.length > 0 ? data[0].value : ''
        }

        this.delDashboardButtonVisible = this.userSession.getLoggedOperator().hasPermission(Activity.WEBSIMAX_DASHBOARD_DEL)

        this.dashboardDescription = BackwardCompatibilityHelper.OpDescrToDescrModel(this.options.dashboardModel.name)
        if (this.dashboardDescription && !this.options.descriptions.some((d: DescrModel) => d.idDescr === this.dashboardDescription.idDescr)) {
            this.options.descriptions.push(this.dashboardDescription)
        }

        this.formOptions = {
            colCount: 1,
            onInitialized: (e: any) => {
                this.form = e.component
            },
            bindingOptions: {
                'formData': '$ctrl.options.dashboardModel'
            },
            labelLocation: 'top',
            scrollingEnabled: true,
            items: this.getFormFields()
        }

        if (!this.options.isNew) {

        }

        this.deleteConfirmationPopupTitle = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Confirm)

        this.deleteDashboardButtonOptions = {
            template: TemplateHelper.getIcon(ConfigHelper.Icon.DELETE, this.userSession),
            hint: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Delete),
            height: 40,
            width: 60,
            onInitialized: (e: any) => {
            },
            onClick: (e: any) => {
                this.$scope.$broadcast(
                    EventsNames.OPEN_CONFIRMATION_POPUP + this.deleteConfirmationPopupId,
                    LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ConfirmDeleteDashboard)
                )
            }
        }

        this.addDashboardSelectboxOptions = {
            valueExpr: 'id',
            displayExpr: 'name',
            value: this.options.dashboardModel.type || Enums.DashboardType.Standard,
            onValueChanged: (e: any) => {
                this.selectedDashboardType = e.value
                this.options.dashboardModel.type = e.value
                this.form.option({ items: this.getFormFields() })
            },
            dataSource: new DataSource([
                {
                    id: Enums.DashboardType.Standard,
                    name: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Dashboard)
                },
                {
                    id: Enums.DashboardType.DXDashboard,
                    name: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.DxDashboard)
                },
            ])
        }

        this.applyChangesButtonOptions = {
            text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Apply),
            onInitialized: (e: any) => {
            },
            onClick: () => {
                if (this.options.onSubmitCallback) {
                    const url: string = this.options.dashboardModel['url']
                    if (this.options.dashboardModel.type === Enums.DashboardType.DXDashboard || this.options.dashboardModel.type === Enums.DashboardType.DXDashboardMulti) {
                        if (!this.options.dashboardModel.dataList) {
                            this.options.dashboardModel.dataList = new OpDataList<OpDashboardData>()
                        }
                        const data: OpDashboardData[] = this.options.dashboardModel.dataList.toArray().filter(d => d.idDataType === Enums.DataType.DASHBOARD_DX_PATH)
                        let idDashboardData: number = null
                        let indexNbr: number = null

                        if (data != null && data.length > 0) {
                            idDashboardData = data[0].idDashboardData
                            indexNbr = data[0].indexNbr
                        }

                        this.options.dashboardModel.dataList.setValue(url, Enums.DataType.DASHBOARD_DX_PATH, indexNbr, idDashboardData)
                    }

                    this.options.onSubmitCallback(this.options.dashboardModel)
                }

                this.popup.hide()
                this.form.resetValues()
            },
            height: 34
        }

        this.cancelChangesButtonOptions = {
            text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Cancel),
            onInitialized: (e: any) => {
            },
            onClick: () => {
                this.popup.hide()
                this.form.resetValues()
            },
            height: 34
        }

        this.applyDashboardDelete = () => {
            if (this.options.onSubmitCallback) {
                this.popup.hide()
                this.options.dashboardModel.opState = Enums.OpChangeState.Delete
                this.options.onSubmitCallback(this.options.dashboardModel)
            }
        }

        this.onDashboardDescrSelectionChanged = (elementId: number, propertyName: string, descr: DescrModel) => {
            this.options.dashboardModel.name = BackwardCompatibilityHelper.DescrModelToOpDescr(descr)
            this.dashboardDescription = descr
        }
    }

    private getPopup(): ng.IPromise<DevExpress.ui.dxPopup> {
        const deferred: ng.IDeferred<DevExpress.ui.dxPopup> = this.$q.defer<DevExpress.ui.dxPopup>()
        if (this.popup) {
            deferred.resolve(this.popup)
        } else {
            this.popupOptions = {
                onInitialized: (e: any) => {
                    this.popup = e.component
                    deferred.resolve(this.popup)
                },
                width: 400,
                maxHeight: 500
            }
        }
        return deferred.promise
    }

    private getFormFields(): DevExpress.ui.dxFormSimpleItem[] {
        const items: DevExpress.ui.dxFormSimpleItem[] = []
        items.push(<DevExpress.ui.dxFormSimpleItem>{
            dataField: 'name',
            label: {
                text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Name)
            },
            template: '<select-add-descr current="$ctrl.dashboardDescription" descriptions="$ctrl.options.descriptions" property-name="$ctrl.options.descriptions" type="' + DescrType.ItemField + '" callback="$ctrl.onDashboardDescrSelectionChanged"></select-add-descr>'
        })

        if (this.options.dashboardModel.type === Enums.DashboardType.Standard) {
            items.push(...[<DevExpress.ui.dxFormSimpleItem>{
                dataField: 'maxWidth',
                label: {
                    text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.MaxWidthInPx),
                },
                editorType: 'dxNumberBox',
                editorOptions: {
                    format: "###0",
                    min: 0,
                }
            }, <DevExpress.ui.dxFormSimpleItem>{
                dataField: 'width',
                label: {
                    text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.WidthInPx),
                },
                editorType: 'dxNumberBox',
                editorOptions: {
                    format: "###0",
                    min: 0,
                }
            }, <DevExpress.ui.dxFormSimpleItem>{
                dataField: 'fitToScreen',
                label: {
                    text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.FitToScreen)
                },
                editorType: 'dxCheckBox'
            }, <DevExpress.ui.dxFormSimpleItem>{
                dataField: 'keepAspectRatio',
                label: {
                    text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.KeepAspectRatio)
                },
                editorType: 'dxCheckBox'
            }, <DevExpress.ui.dxFormSimpleItem>{
                dataField: 'backgroundColor',
                label: {
                    text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.BackgroundColor)
                },
                editorType: 'dxColorBox',
                editorOptions: {
                    applyValueMode: "instantly"
                }
            }])
        }
        if (this.options.dashboardModel.type === Enums.DashboardType.DXDashboard ||
            this.options.dashboardModel.type === Enums.DashboardType.DXDashboardMulti) {
            items.push(<DevExpress.ui.dxFormSimpleItem>{
                dataField: 'url',
                label: {
                    text: LocalizationHelper.getLocalizedText('Url'),
                },
                editorType: 'dxTextBox',
                editorOptions: <DevExpress.ui.dxTextBoxOptions>{

                }
            })
        }

        if (!this.options.isNew && this.options.dashboardModel.type === Enums.DashboardType.Standard) {
            items.push(<DevExpress.ui.dxFormSimpleItem>{
                dataField: 'idStartupIndicator',
                label: {
                    text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Controls)
                },
                editorType: 'dxSelectBox',
                editorOptions: <DevExpress.ui.dxSelectBoxOptions>{
                    noDataText: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoData),
                    placeholder: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Select),
                    showClearButton: true,
                    dataSource: this.options.dashboardModel.controls.filter(x => x.opState !== OpChangeState.Delete && x.opState !== OpChangeState.New).map(x => { return { id: x.type.idDescr, value: x.type.description } }),
                    displayExpr: 'value',
                    valueExpr: 'id'
                }
            })
        }

        return items
    }
}